class AddPlanDialogController {
  constructor($mdDialog, $mdToast, Plan, plans, user) {
    this.$mdDialog = $mdDialog;
    this.Plan = Plan;
    this.plans = plans;
    this.user = user;
    this.$mdToast = $mdToast;
  }
  async addPlan() {
    const {
      Plan, user, plan, days, $mdToast, $mdDialog,
    } = this;

    const assignPlan = await Plan.assign({ user, plan, days });
    $mdToast.show($mdToast.simple().textContent('Plan agregado satisfactoriamente'));
    $mdDialog.hide(assignPlan);
  }
  close() {
    const { $mdDialog } = this;
    $mdDialog.cancel();
  }
}
AddPlanDialogController.$inject = ['$mdDialog', '$mdToast', 'Plan', 'plans', 'user'];
export default AddPlanDialogController;



// WEBPACK FOOTER //
// ./client/app/components/plan/addPlanDialog/addPlanDialog.controller.js